<template>
  <v-container
    fluid
    class="fill-height d-flex flex-column justify-center align-center"
    style="background: linear-gradient(135deg, #1a2842, #495e79)"
  >
    <div class="d-flex flex-column align-center mb-6">
      <v-img
        src="@/assets/mobipoly-logo.png"
        alt="Mobipoly Logo"
        height="130"
        width="130"
        class=""
        contain
      />
    </div>
    <div class="text-white mb-2 text-h6 text-center" style="font-weight: 500">
      Welcome Banker
    </div>
    <v-icon color="white" size="48" class="mb-4" style="opacity: 0.5"
      >mdi-bank</v-icon
    >
    <div class="gamecode-row mb-6 d-flex align-center justify-center">
      <div class="gamecode-text mr-2">{{ gameCode }}</div>
      <v-btn icon variant="text" class="copy-btn" @click="copyCode"
        ><v-icon color="white">mdi-content-copy</v-icon></v-btn
      >
      <v-btn icon variant="text" class="copy-btn" @click="regenerateCode"
        ><v-icon color="white">mdi-refresh</v-icon></v-btn
      >
    </div>
    <v-btn flat class="create-btn mb-5" width="250" @click="startGame">
      Start Game
    </v-btn>
    <v-btn flat class="gradient-border" width="250" large @click="goBack">
      Back
    </v-btn>
  </v-container>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "@/firebase";

const router = useRouter();
const gameCode = ref(generateCode());

function generateCode() {
  return Math.floor(1000 + Math.random() * 9000).toString();
}

async function startGame() {
  const code = gameCode.value;
  const roomRef = doc(db, "rooms", code);
  const roomSnap = await getDoc(roomRef);

  if (roomSnap.exists()) {
    alert("Room code already exists, please regenerate the code");
    return;
  }

  await setDoc(roomRef, {
    poolAmount: 0,
    players: [],
    transactionHistory: [],
  });

  router.push({ name: "GameDashboard", query: { role: "banker", code } });
}

function goBack() {
  router.push("/choosescreen");
}

function copyCode() {
  navigator.clipboard.writeText(gameCode.value);
}

function regenerateCode() {
  gameCode.value = generateCode();
}
</script>

<style scoped>
.gamecode-row {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 8px 18px 8px 18px;
  min-width: 175px;
  max-height: 50px;
}

.gamecode-text {
  letter-spacing: 0.12em;
  color: #fff;
  font-size: 2.2rem;
  font-weight: 700;
  text-align: center;
  font-family: "JetBrains Mono", "Consolas", "monospace";
  user-select: all;
}

.create-btn {
  background: linear-gradient(90deg, #1f7673 0%, #156bae 100%);
  color: #fff !important;
  border-radius: 0px;
  font-size: 1.1rem;
  text-transform: none;
}

.create-btn:hover {
  background: linear-gradient(45deg, #156bae, #1f7673);
}

.gradient-border {
  background: transparent !important;
  border: 2px solid;
  border-image-slice: 1;
  border-width: 2px;
  border-image-source: linear-gradient(45deg, #1f7673, #156bae);
  color: #fff;
  text-transform: none;
  box-shadow: none;
}
.copy-btn {
  min-width: 36px !important;
}
</style>
